import Sidebar from './common/Sidebar';
import { Box, Typography } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import SolutionShape from './shapes/SolutionShape';
import ConditionShape from './shapes/ConditionShape';
import ConfirmModal from 'components/modal/ConfirmModal';
import ActionButton from 'components/button/ActionButton';
import SolutionTaskShape from './shapes/SolutionTaskShape';
import useEditWorkFlowHook from './hooks/useEditWorkFlowHook';
import { Controls, ReactFlow, Background } from '@xyflow/react';
import EdgeConfigurationDrawer from './drawer/EdgeConfigurationDrawer';
import NodeConfigurationDrawer from './drawer/NodeConfigurationDrawer';

const EditButton = ({ handleEditFlow, handleUpdateSolution }) => {
	return (
		<Box
			sx={{
				gap: 1,
				top: 16,
				right: 16,
				zIndex: 999,
				display: 'flex',
				alignItems: 'center',
				// position: 'absolute',
			}}
		>
			<ActionButton onClick={handleUpdateSolution} variantType="add" label="Solution" tooltip="Update Solution" />
			<ActionButton onClick={handleEditFlow} startIcon={<SaveIcon />} variantType="save" label="Update" tooltip="Update workflow" />

			{/* <Tooltip title="Update flow" arrow>
				<Fab
					size="medium"
					color="primary"
					onClick={handleEditFlow}
					aria-label="submit flow"
					sx={{
						boxShadow: '0 6px 18px rgba(25,118,210,0.25)',
						transition: 'transform 0.12s ease, box-shadow 0.12s ease',
					}}
				>
					<SaveIcon />
				</Fab>
			</Tooltip> */}
		</Box>
	);
};

const nodeTypes = {
	solution: SolutionShape,
	condition: ConditionShape,
	solution_task: SolutionTaskShape,
};

// function Sidebar() {
// 	const onDragStart = (event, nodeType) => {
// 		event.dataTransfer.setData('application/reactflow', nodeType);
// 		event.dataTransfer.effectAllowed = 'move';
// 	};

// 	return (
// 		<aside style={{ padding: 10, borderRight: '1px solid #ddd', background: '#fff' }}>
// 			{/* <div
// 				style={{ padding: '10px 10px 5px 10px', background: '#eee', cursor: 'grab', marginBottom: 10 }}
// 				onDragStart={(e) => onDragStart(e, 'solution')}
// 				draggable
// 			>
// 				<ConnectIcon />
// 			</div> */}

// 			<div
// 				style={{
// 					marginBottom: 10,
// 					padding: '10px 10px 5px 10px',
// 					background: '#eee',
// 					cursor: 'grab',
// 				}}
// 				onDragStart={(e) => onDragStart(e, 'solution_task')}
// 				draggable
// 			>
// 				<TaskIcon />
// 			</div>

// 			<div
// 				style={{
// 					padding: '10px 10px 5px 10px',
// 					background: '#eee',
// 					cursor: 'grab',
// 				}}
// 				onDragStart={(e) => onDragStart(e, 'condition')}
// 				draggable
// 			>
// 				<ConditionIcon />
// 			</div>
// 		</aside>
// 	);
// }

const Header = ({ handleEditFlow, handleUpdateSolution, nodes }) => {
	const solutionData = nodes?.find((item) => item?.type === 'solution')?.data ?? null;

	return (
		<Box
			sx={{
				display: 'flex',
				marginTop: '40px',
				background: '#fff',
				alignItems: 'center',
				// p: '10px 24px 10px 65px',
				p: '10px 24px 10px 24px',
				justifyContent: 'space-between',
				borderBottom: '1px solid #E5E7EB',
				boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
			}}
		>
			<Box>
				<Typography fontWeight={600} fontSize={18} sx={{ color: solutionData?.solution?.name ? '#1F2937' : '#EF4444' }}>
					{solutionData?.solution?.name ?? 'Please create solution first'}
				</Typography>

				<Typography fontWeight={400} fontSize={14} sx={{ color: solutionData?.solution?.verticalName ? '#6B7280' : '#EF4444' }}>
					Vertical: {solutionData?.solution?.verticalName ?? 'No vertical selected'}
				</Typography>
			</Box>

			<EditButton handleEditFlow={handleEditFlow} handleUpdateSolution={handleUpdateSolution} />
		</Box>
	);
};

const WorkflowEdit = () => {
	const {
		nodes,
		edges,
		onDrop,
		setEdges,
		isLoading,
		setNodes,
		showModal,
		onConnect,
		onDragOver,
		isModalOpen,
		handleSubmit,
		setShowModal,
		flowInstance,
		selectedNode,
		selectedEdge,
		onNodesChange,
		onEdgesChange,
		setIsModalOpen,
		setSelectedNode,
		isEdgeModalOpen,
		setSelectedEdge,
		reactFlowWrapper,
		activationStatus,
		setIsEdgeModalOpen,
		handleUpdateSolution,
	} = useEditWorkFlowHook();

	return (
		<>
			<Header nodes={nodes} handleEditFlow={() => setShowModal(true)} handleUpdateSolution={handleUpdateSolution} />

			<Box sx={{ display: 'flex', height: '85vh', position: 'relative' }}>
				{/* <Sidebar /> */}

				<Box sx={{ flex: 1 }} ref={reactFlowWrapper}>
					<ReactFlow
						fitView
						nodes={nodes}
						edges={edges}
						onDrop={onDrop}
						nodeTypes={nodeTypes}
						onConnect={onConnect}
						onDragOver={onDragOver}
						onNodesChange={onNodesChange}
						onEdgesChange={onEdgesChange}
						onInit={(instance) => (flowInstance.current = instance)}
						onNodeClick={(event, node) => {
							setSelectedNode(node);
							setIsModalOpen(true);
						}}
						onEdgeClick={(event, edge) => {
							setSelectedEdge(edge);
							setIsEdgeModalOpen(true);
						}}
					>
						<Controls />
						<Background />
					</ReactFlow>

					{/* <EditButton handleEditFlow={() => setShowModal(true)} handleUpdateSolution={handleUpdateSolution} /> */}
				</Box>

				{isModalOpen && selectedNode && (
					<NodeConfigurationDrawer
						screen="edit"
						nodes={nodes}
						node={selectedNode}
						setNodes={setNodes}
						setEdges={setEdges}
						activationStatus={activationStatus}
						onClose={() => setIsModalOpen(false)}
					/>
				)}

				{isEdgeModalOpen && selectedEdge && (
					<EdgeConfigurationDrawer edge={selectedEdge} setNodes={setNodes} setEdges={setEdges} onClose={() => setIsEdgeModalOpen(false)} />
				)}

				{showModal && (
					<ConfirmModal
						showModal={showModal}
						handleSubmit={handleSubmit}
						setShowModal={setShowModal}
						modalData={{
							head: 'Workflow update',
							label: (
								<p>
									Do you want to <b style={{ fontSize: '1rem' }}>Update</b> ?
								</p>
							),
						}}
					/>
				)}
			</Box>
		</>
	);
};

export default WorkflowEdit;
